import { Injectable } from '@angular/core';
import {
  Router, Resolve
}                                 from '@angular/router';
import { Observable, of, EMPTY }  from 'rxjs';
import { mergeMap, take }         from 'rxjs/operators';
import { NeproseService } from '../services/neprose.service';

@Injectable({
  providedIn: 'root'
})
export class ProvinceResolverService implements Resolve<any>{

  constructor( private neproseService: NeproseService, private router: Router) { }

  resolve(): Observable<any> | Observable<never>{
    return this.neproseService.getProvinceList().pipe(
      take(1),
      mergeMap(data=> {
        if (data) {
          return of(data);
        } else {
          this.router.navigate(['']);
        }
      })
    )
  }

}
